var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58292 15.5C1.00268 15.5 0.590265 15.2292 0.345668 14.6875C0.101057 14.1458 0.18014 13.6528 0.582918 13.2083L5.74959 7.375V1.75H4.66625C4.48917 1.75 4.34073 1.68976 4.22094 1.56927C4.10115 1.44877 4.04125 1.29947 4.04125 1.12135C4.04125 0.943229 4.10115 0.795139 4.22094 0.677083C4.34073 0.559028 4.48917 0.5 4.66625 0.5H11.3329C11.51 0.5 11.6584 0.560243 11.7782 0.680729C11.898 0.801229 11.9579 0.950535 11.9579 1.12865C11.9579 1.30677 11.898 1.45486 11.7782 1.57292C11.6584 1.69097 11.51 1.75 11.3329 1.75H10.2496V7.375L15.4163 13.2083C15.819 13.6528 15.8981 14.1458 15.6535 14.6875C15.4089 15.2292 14.9965 15.5 14.4163 15.5H1.58292ZM1.33292 14.25H14.6663L8.99959 7.83333V1.75H6.99959V7.83333L1.33292 14.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.7859a1721b95e4434c2cff4a47d87abe.svg";
export { ForwardRef as ReactComponent };